import './Dialog.less';

const rootId = 'we-dialog';
let rootEl = document.getElementById(rootId);
if (!rootEl) {
  rootEl = document.createElement('div');
  rootEl.id = rootId;
  document.body.appendChild(rootEl);
}

const createDialogWrapEl = (opts) => {
  rootEl.innerHTML =     `
      <div class="dialog-mask"></div>
      <div class="dialog-wrap">
        <div class="dialog-title">
          <span>${opts.title}</span>
          <span class="close-dialog-btn"></span>
        </div>
        <div class="dialog-content">
          <div class="dialog-detail">${opts.content}</div>
        </div>
        <div class="${opts.hideCloseBtn ? 'dialog-btn hide-close-btn' : 'dialog-btn'}">
          <button class="main-button confirm">${opts.confirmTxt}</button>
          <button class="main-button close">${opts.closeTxt}</button>
        </div>
      </div>
    `;
  rootEl.style.display = 'block';
  // 按钮控件
  const confirmEl = rootEl.querySelector('.dialog-btn .confirm');
  const closeEl = rootEl.querySelector('.dialog-btn .close');
  const closeDialogBtnEl = rootEl.querySelector('.dialog-wrap .close-dialog-btn');
  // 绑定按钮事件
  confirmEl.addEventListener('click', () => {
    console.log('>>> confirm:');
    opts.confirmFn && opts.confirmFn();
    run({ show: false });
  }, false);
  closeEl.addEventListener('click', () => {
    console.log('>>> close:');
    opts.closeFn && opts.closeFn();
    run({ show: false });
  }, false);
  closeDialogBtnEl.addEventListener('click', () => {
    run({ show: false });
  }, false);
};

const run = (options) => {
  const opts = Object.assign({}, {
    show: true,
    title: '提示',
    content: '当前微信版本较低，您可以在浏览器工具栏上选择“复制链接”或“浏览器打开”',
    confirmTxt: '复制链接',
    closeTxt: '关闭',
    hideCloseBtn: false,
    confirmFn: () => {},
    closeFn: () => {},
  }, options);

  const dialogWrapEl = rootEl.querySelector('.dialog-wrap');
  if (!dialogWrapEl) {
    createDialogWrapEl(opts);
    return true;
  }
  if (opts.show) {
    rootEl.style.display = 'block';
  } else {
    rootEl.style.display = 'none';
  }
};

export default run;
